import Routine, { RUN } from "+/Engine/Routine";
import DataTypes from "+/Engine/Helpers/DataTypes";

export default class GetEntities extends Routine {
  assertValidParams(params) {
    DataTypes.assertObjectKeyExistsOfType("entityType", params, DataTypes.assertString);
    DataTypes.assertObjectKeyExistsOfType("whereCriteria", params, DataTypes.assertObject);
  }

  [RUN](params) {
    const { entityType, whereCriteria } = params;
    return this.app.getAllEntitiesOfType(entityType).filter(entity => {
      return Object.entries(whereCriteria).every(([fieldName, criterion]) => {
        return this.#evaluateCriterion(entity[fieldName], criterion);
      });
    });
  }

  #evaluateCriterion(entityValue, criterion) {
    switch (criterion.operator) {
      case "equals": return entityValue == criterion.value;
      case "greaterThan": return Number(entityValue) > Number(criterion.value);
      case "lessThan": return Number(entityValue) < Number(criterion.value);
      default:
        throw new Error(`unknown whereCriteria operator "${criterion.operator}"`);
    }
  }
}
Routine.register("GetEntities", GetEntities);
